module.exports = __webpack_public_path__ + "static/media/5D.e6da2691.svg";